import React, { useState, useEffect, useCallback } from "react";
import pMinDelay from "p-min-delay";
import loadable from "@loadable/component";
import moment from "moment";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AllApplicants from "./AllApplicants";
import Recruiters from "./Recruiters";
import Job from "./Job";
import Editor from "./Editor";
import { dashboardHistoryAPI } from "../../api/dashboard";
import { sidebarAPI } from "../../api/menu";

const PieChartDashboard = loadable(() =>
  pMinDelay(import("./pieChartDashboard"), 1000)
);

function Index(props) {
  const { dashboard_box } = props.user;
  const [dashboardBox, setDashboardBox] = useState([]);
  const [reportData, setReportData] = useState({});
  const [menuList, setMenuList] = useState([]);
  const [startDate, setStartDate] = useState(
    moment().subtract(1, "day").toDate()
  );

  const saveDashboardBox = useCallback(
    (boxdata) => {
      const boxArray = boxdata.split(",");
      setDashboardBox(boxArray);
    },
    [setDashboardBox]
  );

  useEffect(() => {
    if (dashboard_box) {
      saveDashboardBox(dashboard_box);
    }
  }, [dashboard_box]);

  const fetchReportData = useCallback(async () => {
    let d = await dashboardHistoryAPI({
      created_at: moment(startDate).format("yyyy-MM-DD"),
    });
    setReportData(d);
  }, [setReportData, startDate]);

  useEffect(() => {
    if (startDate) {
      fetchReportData();
    }
  }, [startDate]);

  useEffect(() => {
    setMenu();
  }, []);

  const setMenu = useCallback(async () => {
    let pdata = JSON.parse(localStorage.getItem("userDetails"));
    let mdata = await sidebarAPI(pdata.roleid);
    if (mdata === false) {
      setMenuList([]);
    } else {
      const access = [];
      mdata.forEach((element) => {
        access.push(element.to);
      });
      setMenuList(access);
    }
  }, []);

  return (
    <>
      <div className="row">
        <div className="row mb-2 align-items-center">
          <div className="col-auto">
            <label className="col-form-label">Select Date</label>
          </div>
          <div className="col-auto">
            <DatePicker
              className={`form-control`}
              dateFormat="Y-MM-dd"
              maxDate={moment().subtract(1, "day").toDate()}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="Select date"
              onFocus={(e) => e.target.blur()}
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
          </div>
        </div>
        <div className="col-xl-6">
          <div className="row">
            {dashboardBox.includes("AAP") && menuList.includes("c_lists") && (
              <AllApplicants appl={reportData?.all_applicants ?? {}} />
            )}
            {dashboardBox.includes("RCT") &&
              menuList.includes("recruiter_list") && (
                <Recruiters appl={reportData?.recruiters ?? {}} />
              )}
            {dashboardBox.includes("JOB") && menuList.includes("job_list") && (
              <Job appl={reportData?.jobs ?? {}} />
            )}
            {dashboardBox.includes("EDT") && (
              <Editor data={reportData?.editors ?? {}} />
            )}
          </div>
        </div>
        <div className="col-xl-6">
          <div className="row">
            {dashboardBox.includes("SKL") && (
              <PieChartDashboard
                type="Skills"
                data={reportData?.skills ?? []}
              />
            )}
            {dashboardBox.includes("LOC") && (
              <PieChartDashboard
                type="Locations"
                data={reportData?.locations ?? []}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { auth } = state;
  return { user: auth?.auth };
}

export default connect(mapStateToProps)(Index);
